import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  addArray
} from '../redux/personalDates'
import * as CalendarItemTypes from 'const/CalendarItemTypes'

export default function * fetchPersonalDates (action) {
  yield put(setLoadStatus({
    isLoading: true,
    isLoaded: false
  }))

  try {
    const { Events: PersonalDates } = yield call(apiGetData, 'PersonalDates', { limit: 9999 })

    yield put([
      addArray(PersonalDates.map(PersonalDate => ({
        id: PersonalDate.Id,
        cardId: PersonalDate.CardId,
        type: CalendarItemTypes.PERSONAL,
        name: PersonalDate.Name,
        timestamp: PersonalDate.Timestamp
      }))),
      setLoadStatus({
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))
  }
}
